module.exports = "/_next/static/images/circlestar-21ac9eea536507e67834bd2b91d55e25.svg";